import '../../utils/index.mjs';
import Cascader from './src/cascader2.mjs';
export { cascaderEmits, cascaderProps } from './src/cascader.mjs';
import './src/instances.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElCascader = withInstall(Cascader);

export { ElCascader, ElCascader as default };
//# sourceMappingURL=index.mjs.map
